import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";
export default {
  mixins: [mixx],
  name: 'fd',
  data() {
    return {
      procesado: false,
      files: [],
      dropContainer: {},
      tabla: [],
      
    };
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $(".box").boxWidget();
    this.dropContainer = document.getElementById("dropcontainer");
    this.fileInput = document.getElementById("images");
   // this.historico()
  }, methods: {
    showModal() {
      this.historico();
      $('#tnLiqCargadas').modal('show');
    },
    drop(e) {
      e.preventDefault(); this.dropContainer.classList.remove("drag-active");
      this.fileInput.files = e.dataTransfer.files;
      this.setFiles(1)
    },
    setFiles(st) {
      this.files = [];
      for (let i = 0; i < this.fileInput.files.length; i++) {
        this.files.push({ status: st, name: this.fileInput.files[i].name, detalle: "" });
      }
      
      this.procesado=false
    },
    inputDropArea() {
      this.setFiles(1)
    },
    dragover(e) { 
      e.preventDefault()
    },
    removeFile(index) {

      if (!this.procesado) {
        const dt = new DataTransfer()
        const input = this.fileInput;
        const { files } = input

        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          if (index !== i)
            dt.items.add(file)
        }

        input.files = dt.files;
        
        this.setFiles(1);
      }


    },
    cargar(i) {
      if (this.fileInput.files.length > i) {
        let formData = new FormData();
        formData.append('file', this.fileInput.files[i]);
        console.log(this.fileInput.files[i])

        this.$http
          .post(
            '/config/fd/archivo',
            formData)
          .then((r) => {
            this.files[i].status = 3;
            this.files[i].detalle = r.data.detalle;
          }).catch((e) => {
            this.files[i].status = 4;
            this.files[i].detalle = e.response.data.error;
          }).finally(e => {
            this.cargar(i + 1)
          })
      }

    },
    historico() {
      this.tabla = [];
      this.$http
        .get('/config/fd/historico')
        .then((r) => {
          console.log(r.data)
          this.tabla = r.data;
        }).catch((e) => {
          this.tabla = [];
        })
    }
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/configs/cargarArchivoFD/index.js